/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetLocationStatusRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {BatchGetLocationStatusResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const batchGetLocationStatus = (request:BatchGetLocationStatusRequest, options?: CashRequestOptions) => post<BatchGetLocationStatusRequest, BatchGetLocationStatusResponse>("/2.0/cash/batch-get-location-status", request, {...options, rejectOnError: true })